export const MUSE2_ALPHA_ENROLLMENT_PATH = "/app/muse-2-alpha";

export function normalizeMuse2AlphaCampaign(value) {
  return typeof value === "string" && /^[a-zA-Z0-9_.-]{1,64}$/.test(value) ? value : "muse2-alpha";
}

export function isMuse2AlphaEnrollmentPath(pathname) {
  return pathname === MUSE2_ALPHA_ENROLLMENT_PATH || pathname === `${MUSE2_ALPHA_ENROLLMENT_PATH}/`;
}

// Keep the email-login return destination local and limited to this enrollment flow.
export function muse2AlphaSignInNext(pathname, search) {
  if (!isMuse2AlphaEnrollmentPath(pathname)) return undefined;
  const campaign = normalizeMuse2AlphaCampaign(new URLSearchParams(search).get("campaign"));
  return `${MUSE2_ALPHA_ENROLLMENT_PATH}?campaign=${campaign}`;
}

// A gate grant makes an account eligible; the enrollment link records acceptance.
export function hasJoinedMuse2AlphaPhase2(features, enrollment) {
  return features?.muse2AlphaPhase2 === true && !!enrollment?.joinedAt;
}
